"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BandageAbilityHandler = exports.BandageActorAbilityFactory = exports.BandageAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Regeneration_1 = require("../../core/effects/core/Regeneration");
const Registries_1 = require("../../core/state/Registries");
class BandageAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bandage;
        this.__typeName = "Bandage";
    }
}
exports.BandageAbilityArgs = BandageAbilityArgs;
let BandageActorAbilityFactory = class BandageActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bandage", "Self", 2);
    }
};
BandageActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bandage")
], BandageActorAbilityFactory);
exports.BandageActorAbilityFactory = BandageActorAbilityFactory;
let BandageAbilityHandler = class BandageAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyHealing({
                    sequence,
                    animate: false,
                    healerId: ability.invokerId,
                    targetId: ability.invokerId,
                    amount: container.getPercentOfBaseHealth(ability.invokerId, 25),
                    attributePercent: 0,
                    onApplied: sequence => {
                        container.applyBuff({
                            sequence,
                            creatorId: ability.invokerId,
                            targetId: ability.invokerId,
                            duration: Duration_1.Duration.Turns(4),
                            effect: new Regeneration_1.RegenerationEffectArgs("Bandage", container.getPercentOfBaseHealth(ability.invokerId, 2)),
                        });
                    }
                });
            }
        });
    }
};
BandageAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bandage)
], BandageAbilityHandler);
exports.BandageAbilityHandler = BandageAbilityHandler;
